<p-confirmDialog></p-confirmDialog>
<div class="map-form-container flex flex-row justify-content-between flex-wrap">
  <div class="map-section col-6">
    @if (center.length > 0 && !isLoadingMap) {
      <mfs-old-map
        [allowDrawUnderSibling]="false"
        [height]="'100%'"
        [zoom]="18"
        [drawingMode]="!isPlannedSowing"
        [polygonJson]="formData.polygonJson"
        [parentPolygonJson]="this.parentField?.polygonJson"
        [(geometry)]="config.data.model.polygon"
        [(polygonArea)]="config.data.model.fieldArea"
        [isCenterMarker]="false"
        [polygonColor]="cropColor"
        [polygonName]="cropName"
        (polygonSplit)="afterSplit($event)"
        [center]="center"
        [canSave]="canSave"
        (canSaveChange)="onMapCanSaveChange($event)"
        [isLoading]="isLoadingMap"
        [showCopyParentBtn]="!isPlannedSowing"
        [siblingPolygons]="activeSeasonsPolygonJson"
        showCopyParentContourLabel="Create Contour"
      ></mfs-old-map>
    } @else {
      @if (isLoadingMap) {
        <div class="map-loading flex flex-column justify-content-center align-items-center">
          <app-loading [loading]="isLoadingMap"></app-loading>
        </div>
      } @else {
        <h3>{{ "Field boundaries are missing" | translate }}</h3>
      }
    }
  </div>
  <div class="form-section col-6 flex flex-column">
    <div
      class="flex flex-column gap-2"
      style="height: 100%; min-height: 400px">
      <app-tabs
        activeTab="infos"
        [tabs]="tabs"
      ></app-tabs>

      <ng-template #infosTemplate>
        <div
          class="form-block flex-grow-1 overflow-auto"
          style="flex-basis: 0; max-height: calc(100vh - 335px); min-width: 0">
          @if (config.data.fields?.length) {
            <msf-form-builder
              flexDirection="row"
              [fields]="infosFormFields"
              [(model)]="config.data.model"
              (modelChange)="formChange()"></msf-form-builder>
          }
          @if (mainFormDateError) {
            <div class="validation-error">
              <span class="error-text">{{ mainFormDateError }}</span>
            </div>
          }

          <div
            class="mt-1"
            style="padding: 2px">
            <app-season-period-edit
              [(model)]="config.data.model"
              [isPlanned]="isPlannedSowing"
              [canSave]="canSave"
              (modelChange)="formChange()"
              (canSaveChange)="onSeasonPeriodCanSaveChange($event)"></app-season-period-edit>
          </div>
          <div class="mt-2">
            <msf-form-builder
              flexDirection="row"
              [fields]="detailsFields()"
              [(model)]="config.data.model"
              (modelChange)="formChange()"
            ></msf-form-builder>
          </div>
          <div class="pl-1 pr-1">
            <div class="last-update-info mt-1 p-2 bg-gray-100 rounded text-sm text-gray-600">
              <i class="pi pi-clock mr-1"></i>
              {{ "Calculation update date" | translate }}:
              {{ config?.data?.model?.calculationUpdateDate | dateFormatLang: translateService.currentLang }}
            </div>
          </div>
          <div class="mt-1">
            <msf-form-builder
              flexDirection="row"
              [fields]="commentFields()"
              [(model)]="config.data.model"></msf-form-builder>
          </div>
        </div>
      </ng-template>

      <ng-template #sourceTemplate>
        <div class="plan-metadata-fields flex flex-row flex-wrap mb-3">
          <div class="plan-metadata-field col-12 col-md-6">
            <div class="field-label text-sm font-medium mb-1">{{ 'PLAN_DATA_SOURCE' | translate }}</div>
            <div class="last-update-info">{{ planDataSourceLabel }}</div>
          </div>
          <div class="plan-metadata-field col-12 col-md-6">
            <div class="field-label text-sm font-medium mb-1">{{ 'PLAN_DATA_LOCKED_AT' | translate }}</div>
            <div class="last-update-info">
              @if (formData?.planDataLockedAt) {
                {{ formData.planDataLockedAt | dateFormatLang: translateService.currentLang }}
              } @else {
                —
              }
            </div>
          </div>
        </div>
        <msf-form-builder
          flexDirection="row"
          [fields]="sourceForm()"
          [(model)]="config.data.model"
          (modelChange)="formChange()"
        ></msf-form-builder>
      </ng-template>

      <ng-template #contractTemplate>
        <msf-form-builder
          flexDirection="row"
          [fields]="contractForm()"
          [(model)]="config.data.model"
          (modelChange)="formChange()"
        ></msf-form-builder>
        @if (mainFormDateError) {
          <div class="validation-error">
            <span class="error-text">{{ mainFormDateError }}</span>
          </div>
        }
      </ng-template>

      <ng-template #historyTemplate>
        <div
          class="form-block flex-grow-1 overflow-auto"
          style="flex-basis: 0; max-height: calc(100vh - 335px); min-width: 0">
          <app-passport-menu-general-history
            [seasonId]="formData?.id"
            [formConfig]="historyFormFields"
            [subtitle]="'History'"
            [versionTitle]="'Version of changes'"
            [showRestoreButton]="!isPlannedSowing"
            (historyRestored)="onHistoryRestored()"></app-passport-menu-general-history>
        </div>
      </ng-template>


      <p-divider></p-divider>
      <div
        class="flex flex-row mt-3 justify-content-end align-items-end gap-2"
        style="flex-basis: 5%; min-width: 160px">
        <p-button
          [severity]="'secondary'"
          label="{{ 'Отменить' | translate }}"
          class="p-button-text button-secondary"
          (click)="cancel()"></p-button>
        @if (!isPlannedSowing) {
          <button
            pButton
            type="button"
            label="{{ 'Apply' | translate }}"
            class="p-button-primary"
            [disabled]="!canSave || isSaving"
            [loading]="isSaving"
            (click)="save()"></button>
        }
      </div>
    </div>
  </div>
</div>
